<template>
  <component :is="way" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
import { mapGetters } from 'vuex'
import TabResumeDefault from './TabResumeDefault'
import PROCESS_NAMES from '@/process/names'

// const TabResumeSportmaster = () =>
//   import(/* webpackChunkName: "tab-resume-sportmaster" */ "@/process/sportmaster/components/response/tabs/resume")
const TabResumeKpmg = () =>
  import(/* webpackChunkName: "tab-resume-kpmg" */ "@/process/kpmg/components/response/tabs/TabResumeKpmg")

export default {
  components: {
    TabResumeDefault,
    TabResumeKpmg
  },

  computed: {
    ...mapGetters('process', ['getProcessName']),

    way() {
      let way = 'tab-resume'

      if (this.getProcessName === PROCESS_NAMES.KPMG) {
        return `${way}-${this.getProcessName}`
      } else {
        return `${way}-default`
      }
    }
  }
}
</script>
